import React, { useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import sal from "sal.js";
import { Helmet } from "@dr.pogodin/react-helmet";

export default function GoogleCloud() {
  useEffect(() => {
    document.title = "Google Cloud Hosting | Fast & Reliable Cloud";
        sal();
      }, []);
  return (
    <>
      <Helmet>
        <title>Google Cloud Hosting | Fast & Reliable Cloud</title>
        <meta name="description" content="Run your applications on Google Cloud with scalable resources, global performance, and expert support for modern cloud workloads." />
        <meta name="keywords" content="Google Cloud Platform, Google Cloud Storage, Google Cloud Hosting, Google Cloud Services, Gcloud, Google Cloud Web Hosting, Google Cloud Backup, Google Cloud" />
        <meta property="og:url" content={`${import.meta.env.VITE_FRONTEND_URL}/google-cloud`} />
        <link rel="canonical" href={`${import.meta.env.VITE_FRONTEND_WWW_URL}/google-cloud`} />
        <meta property="og:title" content="Trusted Google Cloud Hosting Service Provider" />
        <meta property="og:description" content="Host a website on the Google cloud platform that is fully managed by our experts. We offer easy migration, 99.9% uptime, and 24*7 support to premium clients." />
      </Helmet>
      <div className="wordpress-hosting-banner about-banner pb-120 bg-dark">
          <div className="container">
              <div className="row g-4 align-items-center align-items-xxl-end">
                  <div className="col-lg-7">
                      <div className="d-flex align-items-center gap-2">
                          <div className="w-3 h-3 rounded-circle bg-primary flex-shrink-0"></div>
                          <span className="d-block fw-semibold mb-0 text-primary">
                              High-Key the G.O.A.T. of Web Hosting
                          </span>
                      </div>
                      <h1 className="mb-6 text-white">
                        Google Cloud: Hosting So Smooth, Basically It’s Our Love Language
                      </h1>
                      <p className="text-white max-text-60 mb-8 text-opacity-75">
                          Think that your site feels finally seen, just like it's getting the princess treatment all day long. Zero lag, zero flops, just positive vibes because Google Cloud is holding it down.
                      </p>
                        <Link to="/contact-us" className="btn btn-primary btn-arrow btn-lg fs-14 fw-medium rounded sal-animate btn-height" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine" data-discover="true">
                            <span className="btn-arrow__text">Get Started
                                <span className="btn-arrow__icon">
                                <i className="fa-solid fa-arrow-right"></i>
                                </span>
                            </span>
                        </Link>
                  </div>
                  <div className="col-xl-5 col-lg-5 ipad-mt">
                      <div className="about-banner__img">
                          <img src="images/google-cloud-hosting.webp" alt="image" className="img-fluid full-width-img" />
                      </div>
                  </div>
              </div>
          </div>
      </div>
      <div className="pt-100 pb-100 linux-hosting-points-section">
        <div className="pb-60">
            <div className="container">
              <div className="row g-4 align-items-center justify-content-xl-between">
                  <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                    <small className="d-inline-block mb-2 fw-bold bg-success-subtle text-success-emphasis border border-success-subtle px-3 py-1 rounded"><span className="d-inline-block w-2 h-2 bg-success rounded-circle me-1"></span>Hosting That Feels Like Home</small>
                    <h2 className="mb-4">Where Sites Feel Just Like Home: Happy, All the Time</h2>
                  </div>
                  <div className="col-lg-6 col-xl-5 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="card">
                        <div className="card-body cloud-hosting-vid-card">
                                <div className="features-video position-relative z-1">
                                    <img src="/images/infi-common-video-yt-thumb.jpg" alt="image" className="img-fluid w-100"/>
                                    <Link to="https://youtu.be/x10KM9gI110?si=kVgGnbSAsh-zfKn7" target="_blank" className="btn gradient-bg w-15 h-15 d-grid place-content-center rounded-circle position-absolute top-50 start-50 translate-middle fs-24 text-white popup-init">
                                        <i className="fa-solid fa-play"></i>
                                    </Link>
                                </div>
                            </div>
                    </div>
                  </div>
              </div>
            </div>
        </div>
        <div className="container">
            <div className="row g-4">
              <div className="col-md-6 col-lg-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                  <div className="card border-0 shadow-sm rounded-4 h-100">
                    <div className="card-body p-md-6 p-xl-8">
                        <div className="mb-8"><img alt="image" className="img-fluid" src="/images/cloud-hosting.webp" /></div>
                        <h6 className="mb-4">Cloud Server for Creators</h6>
                        <p className="mb-0">Even if you are a blogger, developer, or expert team, our Google Cloud server is engineered to support your chaos.</p>
                    </div>
                  </div>
              </div>
              <div className="col-md-6 col-lg-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                  <div className="card border-0 shadow-sm rounded-4 h-100">
                    <div className="card-body p-md-6 p-xl-8">
                        <div className="mb-8"><img alt="image" className="img-fluid" src="/images/turnkey-hosting.webp" /></div>
                        <h6 className="mb-4">Hosting for E-Commerce</h6>
                        <p className="mb-0">Emphasize on expanding your brand reach-we’ll manage the tech. Our GCP hosting keeps your store stable.</p>
                    </div>
                  </div>
              </div>
              <div className="col-md-6 col-lg-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="500" data-sal-easing="ease-in-out-sine">
                  <div className="card border-0 shadow-sm rounded-4 h-100">
                    <div className="card-body p-md-6 p-xl-8">
                        <div className="mb-8"><img alt="image" className="img-fluid" src="/images/your-server.webp" /></div>
                        <h6 className="mb-4">Cloud Server for Agencies</h6>
                        <p className="mb-0">Let our GCP-based cloud take care of servers so your team can stay centered on delivering perfect work.</p>
                    </div>
                  </div>
              </div>
              <div className="col-md-6 col-lg-4 sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                  <div className="card border-0 shadow-sm rounded-4 h-100">
                    <div className="card-body p-md-6 p-xl-8">
                        <div className="mb-8"><img alt="image" className="img-fluid" src="/images/control-uae-server.webp" /></div>
                        <h6 className="mb-4">Cloud Server for Enterprises</h6>
                        <p className="mb-0">Our Google Cloud server helps startups get the power and scalability they need, without any crunch.</p>
                    </div>
                  </div>
              </div>
              <div className="col-md-6 col-lg-4 sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                  <div className="card border-0 shadow-sm rounded-4 h-100">
                    <div className="card-body p-md-6 p-xl-8">
                        <div className="mb-8"><img alt="image" className="img-fluid" src="/images/cloud-command.webp" /></div>
                        <h6 className="mb-4">Hosting For Perfection</h6>
                        <p className="mb-0">We generally fine-tune your Managed Google Cloud hosting for smooth deployment and control.</p>
                    </div>
                  </div>
              </div>
              <div className="col-md-6 col-lg-4 sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="500" data-sal-easing="ease-in-out-sine">
                  <div className="card border-0 shadow-sm rounded-4 h-100">
                    <div className="card-body p-md-6 p-xl-8">
                        <div className="mb-8"><img alt="image" className="img-fluid" src="/images/all-eyes-on-gcp.webp" /></div>
                        <h6 className="mb-4">All Eyes on GCP</h6>
                        <p className="mb-0">Always stay updated with every single click on GCP-where real-time meets genuine growth and success.</p>
                    </div>
                  </div>
              </div>
            </div>
        </div>
      </div>

      <div className="pb-60">
        <div className="pb-60">
            <div className="container">
                <div className="row g-4 align-items-center">
                    <div className="col-md-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <img src="images/cloud-hosting-that.webp" alt="image" className="img-fluid" />
                    </div>
                    <div className="col-md-6 ipad-mini-mt">
                        <div className="ps-lg-8 pe-xxl-12">
                            <span className="d-block mb-2 text-primary fs-18 fw-semibold sal-animate" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                We're Always There for You
                            </span>
                            <h3 className="mb-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                Cloud Hosting That’s Got Your Back (& Front-End Too)
                            </h3>
                            <p data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine" className="sal-animate">
                                When the experts' support is flaky and uptime is completely shaky… we are the perfect upgrade.
                            </p>
                                <ul>
                                    <li>1:1 expert assistance with a true GCP cloud expert</li>
                                    <li>FREE setup + migration-we manage everything</li>
                                    <li>24/7 constant monitoring so you don’t lose your calm</li>
                                    <li>Pre-designed templates & guides that make life easier</li>
                                    <li>Full development support that never leaves you on read</li>
                                    <li>A highly experienced support team, characterized by skills</li>
                                </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="pb-60">
            <div className="container">
                <div className="row g-4 align-items-center">
                    <div className="col-md-6">
                        <div className="ps-lg-8 pe-xxl-12">
                            <span className="d-block mb-2 text-primary fs-18 fw-semibold sal-animate" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                No pauses. No outages.
                            </span>
                            <h3 className="mb-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                GCP Got That ‘Always On’: So You Don’t Experience Downtime
                            </h3>
                            <p data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine" className="sal-animate">
                                Get smooth web hosting with Google Cloud-customized just for you and engineered to deliver high performance, etc.
                            </p>
                                <ul>
                                    <li>Auto-scaling that manages the load, even when traffic is high.</li>
                                    <li>Many data centers keep your website available, no matter what.</li>
                                    <li>No downtime, no worries-your website stays up 24/7.</li>
                                    <li>Update & control all things with just a click.</li>
                                    <li>24/7 expert monitoring keeps your cloud secure.</li>
                                    <li>Quick email alerts so you’re always notified.</li>
                                </ul>
                            <Link to="/contact-us" className="btn btn-primary btn-arrow btn-lg fs-14 fw-medium rounded btn-height">
                                <span className="btn-arrow__text">
                                    Get Started Now
                                    <span className="btn-arrow__icon">
                                        <i className="fa-solid fa-arrow-right"></i>
                                    </span>
                                </span>
                            </Link>
                        </div>
                    </div>
                    <div className="col-md-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <img src="images/gcp-got-that-always-on.webp" alt="image" className="img-fluid" />
                    </div>
                </div>
            </div>
        </div>
    </div>

      <section>
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-xxl-7 col-xl-8">
                    <div className="d-flex align-items-center justify-content-center gap-2 mb-2 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <small className="d-inline-block mb-2 fw-bold bg-primary-subtle text-primary-emphasis border border-primary-subtle px-3 py-1 rounded">
                            <span className="d-inline-block w-2 h-2 bg-primary rounded-circle me-1"></span>Turn the page. Go Google Cloud.
                        </small>
                    </div>
                    <div className="text-center mb-8">
                        <h2 className="text-dark mb-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Your Site’s Next Chapter Starts on Google Cloud</h2>
                    </div>
                </div>
            </div>
            <div className="row g-4">
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 p-xl-10 rounded-3 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">Umm... GCP for FREE</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">01</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/umm-gcp-for.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">Smooth, secure, and free migration to our GCP cloud server-no unexpected downtime, no issues.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 rounded-3 p-xl-10 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">Your Cloud, 24/7</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">02</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/basic-support.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">Round-the-clock support for all your GCP cloud hosting problems-anytime, anywhere, every time.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 rounded-3 p-xl-10 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">DevOps That Slay</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">03</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/devops-that.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">Professional reviews and timely audits for your Google Cloud Platform setup-done perfectly.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 rounded-3 p-xl-10 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">Level Up Cloud</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">04</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/level-up-cloud.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">Improve cloud server performance and uptime along with our Google Cloud hosting platform support.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </section>
      <section className="simple-box-section pt-100 pb-80">
        <div className="container">
          <div className="row">
              <div className="col-12">
                  <div className="card rounded-3 cta-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                      <div className="card-body px-6 pt-60 pb-60">
                          <div className="row justify-content-center">
                              <div className="col-md-11 col-lg-8 col-xl-8">
                                  <div className="text-center">
                                    <span className="section-title style-bg fadeInUp mb-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">Join Us</span>
                                      <h4 className="mb-4">
                                          The Cloud Party’s Right Here: Just Get In.
                                      </h4>
                                      <p className="mb-6">
                                        Set Up Google Cloud Hosting Like an Expert (No Coding Required)
                                      </p>
                                      <Link to="tel:7737300013" className="btn btn-primary btn-arrow btn-arrow-xl btn-lg fs-14 fw-medium rounded me-sm-2 btn-height">
                                          <span className="d-inline-block me-1 flex-shrink-0">
                                              <i className="las la-comments"></i>
                                          </span>
                                          <span className="btn-arrow__text">
                                              +91-7737300013
                                              <span className="btn-arrow__icon">
                                                  <i className="fa-solid fa-arrow-right"></i>
                                              </span>
                                          </span>
                                      </Link>
                                      <Link to="#" className="btn btn-primary btn-arrow btn-arrow-xl btn-lg fs-14 fw-medium rounded ms-sm-2 mt-sm-0 mt-4 open-live-chat btn-height">
                                          <span className="d-inline-block me-1 flex-shrink-0">
                                              <i className="las la-comments"></i>
                                          </span>
                                          <span className="btn-arrow__text">
                                              Talk to an Expert
                                              <span className="btn-arrow__icon">
                                                  <i className="fa-solid fa-arrow-right"></i>
                                              </span>
                                          </span>
                                      </Link>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
        </div>
      </section>
    </>
  );
}
